import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Card,
  Typography,
  Grid,
  Box,
  MenuItem,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import { updateProjectChapter, getChapterDetails } from "../Servies/AdmiServices";

export default function EditProjectChapter() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const projectChapterId = queryParams.get("projectChapterId");
 const projectId = queryParams.get("projectId");

  const [chapter, setChapter] = useState({
    projectChapterId: "",
    chapterName: "",
    designerName: "",
    noOfPpt: "",
    noOfVideo: "",
    pptVideoStartDate: "",
    pptVideoEndDate: "",
    microplanRecieved: "",
    microplanName: "",
    microplanDate: "",
    microplanClassworkDate: "",
    pdfResource: "",
    recordingTeacher: "",
    recordingDate: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  // ------------------------------
  const formatDate = (dateArray) => {
    if (!Array.isArray(dateArray) || dateArray.length !== 3) return "";
    const [year, month, day] = dateArray;
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  };

  const dateStringToArray = (dateStr) => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split("-").map(Number);
    return [year, month, day];
  };

  // ------------------------------
  const loadChapterDetails = async () => {
    setIsLoading(true);
    try {
      const res = await getChapterDetails(projectChapterId);
      if (res?.data?.status === "SUCCESS") {
        const data = res.data.response;
        setChapter({
          projectChapterId: data.projectChapterId,
          chapterName: data.chapterName || "",
          designerName: data.designerName || "",
          noOfPpt: data.noOfPpt || "",
          noOfVideo: data.noOfVideo || "",
          pptVideoStartDate: formatDate(data.pptVideoStartDate),
          pptVideoEndDate: formatDate(data.pptVideoEndDate),
          microplanRecieved: data.microplanRecieved || "",
          microplanName: data.microplanName || "",
          microplanDate: formatDate(data.microplanDate),
          microplanClassworkDate: formatDate(data.microplanClassworkDate),
          pdfResource: data.pdfResource || "",
          recordingTeacher: data.recordingTeacher || "",
          recordingDate: formatDate(data.recordingDate),
        });
        // toast.success("✅ Chapter details loaded successfully!");
      } else {
        toast.error("Failed to fetch chapter details");
      }
    } catch (error) {
      toast.error("Error loading chapter details");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (projectChapterId) loadChapterDetails();
  }, [projectChapterId]);

  const handleBack = () => {
  if (projectId) {
    navigate(`/dashboard/ProjectChapters?projectId=${projectId}`);
  } else {
    navigate(-1); // fallback
  }
};
  // ------------------------------
  const handleChange = (field, value) => {
    setChapter((prev) => ({ ...prev, [field]: value }));
  };

  const validateForm = () => {
    const {
      designerName,
      noOfPpt,
      noOfVideo,
      pptVideoStartDate,
      pptVideoEndDate,
      microplanRecieved,
      microplanDate,
      microplanClassworkDate,
      pdfResource,
      recordingTeacher,
      recordingDate,
    } = chapter;

    if (
      !designerName ||
      !noOfPpt ||
      !noOfVideo ||
      !pptVideoStartDate ||
      !pptVideoEndDate ||
      !microplanRecieved ||
      !pdfResource ||
      !recordingTeacher ||
      !recordingDate
    ) {
      toast.error("Please fill all required fields!");
      return false;
    }

    if (microplanRecieved.toUpperCase() === "YES") {
      if (!microplanDate || !microplanClassworkDate) {
        toast.error("Please fill Microplan Date and Classwork Date!");
        return false;
      }
    }

    if (pptVideoEndDate < pptVideoStartDate) {
      toast.error("PPT/Video End Date cannot be before Start Date!");
      return false;
    }

    return true;
  };

  // ------------------------------
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  setIsLoading(true);
  try {
    const payload = {
      projectChapterId: chapter.projectChapterId,
      chapterName: chapter.chapterName,
      designerName: chapter.designerName,
      noOfPpt: Number(chapter.noOfPpt),
      noOfVideo: Number(chapter.noOfVideo),
      pptVideoStartDate: dateStringToArray(chapter.pptVideoStartDate),
      pptVideoEndDate: dateStringToArray(chapter.pptVideoEndDate),
      microplanRecieved: chapter.microplanRecieved.toUpperCase(),
      microplanName: chapter.microplanName,
      microplanDate: chapter.microplanDate ? dateStringToArray(chapter.microplanDate) : null,
      microplanClassworkDate: chapter.microplanClassworkDate ? dateStringToArray(chapter.microplanClassworkDate) : null,
      pdfResource: chapter.pdfResource,
      recordingTeacher: chapter.recordingTeacher,
      recordingDate: dateStringToArray(chapter.recordingDate),
      projectId,
    };

    const res = await updateProjectChapter(payload);
    if (res?.data?.status === "SUCCESS") {
      toast.success(" Chapter Details updated successfully!");

      const prevUrl = document.referrer; 
      if (prevUrl.includes("/ProjectChapters")) {
        window.location.href = prevUrl; 
      } else if (chapter.projectId) {
        navigate(`/dashboard/ProjectChapters?projectId=${chapter.projectId}`);
      } else {
        navigate(-1); 
      }
    } else {
      toast.error(res?.data?.message || "Failed to update chapter");
    }
  } catch {
    toast.error("Error updating chapter");
  } finally {
    setIsLoading(false);
  }
};

  // ------------------------------
  return (
    <>
      <ToastContainer />
      {/* --- Back Button --- */}
            <Box sx={{ padding: "20px 40px" }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleBack}
                sx={{
                  borderColor: "#ccc",
                  "&:hover": { borderColor: "#888" },
                }}
              >
                ← Back 
              </Button>
            </Box>
      <Typography variant="h4"  ml={5}>
        Manage Chapter Details
      </Typography>

      <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
        <Card
          sx={{
            p: 4,
            width: "100%",
            maxWidth: 1100,
            boxShadow: 3,
            backgroundColor: "#fff",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              {/* Project Chapter ID */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Project Chapter ID"
                  fullWidth
                  value={chapter.projectChapterId}
                  disabled
                />
              </Grid>

              {/* Chapter Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Chapter Name"
                  fullWidth
                  required
                  value={chapter.chapterName}
                  onChange={(e) => handleChange("chapterName", e.target.value)}
                />
              </Grid>

              {/* Designer Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Designer Name"
                  fullWidth
                  required
                  value={chapter.designerName}
                  onChange={(e) => handleChange("designerName", e.target.value)}
                />
              </Grid>

              {/* No. of PPT */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="No. of PPT"
                  type="number"
                  fullWidth
                  required
                  value={chapter.noOfPpt}
                  onChange={(e) => handleChange("noOfPpt", e.target.value)}
                />
              </Grid>

              {/* No. of Videos */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="No. of Videos"
                  type="number"
                  fullWidth
                  required
                  value={chapter.noOfVideo}
                  onChange={(e) => handleChange("noOfVideo", e.target.value)}
                />
              </Grid>

              {/* PPT Video Start */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="PPT VIDEO Start Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  value={chapter.pptVideoStartDate}
                  onChange={(e) =>
                    handleChange("pptVideoStartDate", e.target.value)
                  }
                />
              </Grid>

              {/* PPT Video End */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="PPT VIDEO End Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  value={chapter.pptVideoEndDate}
                  onChange={(e) =>
                    handleChange("pptVideoEndDate", e.target.value)
                  }
                />
              </Grid>

              {/* Microplan Received */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Microplan Received"
                  fullWidth
                  required
                  value={chapter.microplanRecieved}
                  onChange={(e) =>
                    handleChange("microplanRecieved", e.target.value)
                  }
                >
                  <MenuItem value="YES">YES</MenuItem>
                  <MenuItem value="NO">NO</MenuItem>
                </TextField>
              </Grid>

              {/* Microplan Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Microplan Name"
                  fullWidth
                  value={chapter.microplanName}
                  onChange={(e) => handleChange("microplanName", e.target.value)}
                />
              </Grid>

              {/* Microplan Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Microplan Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required={chapter.microplanRecieved.toUpperCase() === "YES"}
                  value={chapter.microplanDate}
                  onChange={(e) => handleChange("microplanDate", e.target.value)}
                />
              </Grid>

              {/* Microplan Classwork Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Microplan Classwork Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required={chapter.microplanRecieved.toUpperCase() === "YES"}
                  value={chapter.microplanClassworkDate}
                  onChange={(e) =>
                    handleChange("microplanClassworkDate", e.target.value)
                  }
                />
              </Grid>

              {/* PDF Resource */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="PDF Resource"
                  fullWidth
                  required
                  value={chapter.pdfResource}
                  onChange={(e) => handleChange("pdfResource", e.target.value)}
                >
                  <MenuItem value="true">TRUE</MenuItem>
                  <MenuItem value="false">FALSE</MenuItem>
                </TextField>
              </Grid>

              {/* Recording Teacher */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Recording Teacher"
                  fullWidth
                  required
                  value={chapter.recordingTeacher}
                  onChange={(e) =>
                    handleChange("recordingTeacher", e.target.value)
                  }
                />
              </Grid>

              {/* Recording Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Recording Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  value={chapter.recordingDate}
                  onChange={(e) => handleChange("recordingDate", e.target.value)}
                />
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="center" mt={4}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update"}
              </Button>
            </Box>
          </form>
        </Card>
      </Box>
    </>
  );
}
